
        import i18n from 'i18n';
        import flattenObject from 'util/flattenObject';
    
            import ns7e4a103d710ac8c6a2257d8eb50d3de3en from './en.yaml'
            i18n.addResourceBundle('en', '7e4a103d710ac8c6a2257d8eb50d3de3', flattenObject(ns7e4a103d710ac8c6a2257d8eb50d3de3en), true, true);
        
        export default '7e4a103d710ac8c6a2257d8eb50d3de3';
    